import { AppConsts } from '@shared/AppConsts';
import { Injectable, Injector, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalizationService } from 'abp-ng2-module';
import { CompanyServiceProxy, OrderServiceProxy, Parameter, WarehouseServiceProxy } from '@shared/service-proxies/service-proxies';
import { ValueConverter } from '@angular/compiler/src/render3/view/template';
import { DefaultSettingService } from './default-setting.service';
import { AppComponentBase } from '@shared/app-component-base';
import { AppSessionService } from '@shared/session/app-session.service';
export interface IMenuItem {
  id?: string;
  title?: string;
  description?: string;
  type: string;       // Possible values: link/dropDown/extLink
  name?: string;      // Used as display text for item and title for separator type
  state?: string;     // Router state
  icon?: string;      // Material icon name
  tooltip?: string;   // Tooltip text
  disabled?: boolean; // If true, item will not be appeared in sidenav.
  sub?: IChildItem[]; // Dropdown items
  badges?: IBadge[];
  active?: boolean;
}
export interface IChildItem {
  id?: string;
  parentId?: string;
  type?: string;
  name: string;       // Display text
  state?: string;     // Router state
  icon?: string;
  sub?: IChildItem[];
  active?: boolean;
}

interface IBadge {
  color: string;      // primary/accent/warn/hex color codes(#fff000)
  value: string;      // Display text
}

interface ISidebarState {
  sidenavOpen?: boolean;
  childnavOpen?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class NavigationService{
  public sidebarState: ISidebarState = {
    sidenavOpen: true,
    childnavOpen: false
  };
  menuVisibile:Parameter[]=[];
  defaultMenu: IMenuItem[] =[];
  menuItems = new BehaviorSubject<IMenuItem[]>([]);
  menuItems$ = this.menuItems.asObservable();
  public activeChildMenu: IMenuItem;
  public isChildMenuOpen: boolean = false;

  turkishToLower(str: string): string {
    const letters: { [key: string]: string } = { İ: 'i', I: 'ı', Ş: 'ş', Ü: 'ü', Ö: 'ö', Ç: 'ç' };
    return str.replace(/İ|I|Ş|Ü|Ö|Ç/g, letter => letters[letter]).toLowerCase();
  }
  
  filterMenu(searchTerm: string) {
    const filterRecursive = (items: any[]): any[] => {
      return items.reduce((acc, item) => {
        if (!item.disabled) {
          const itemNameIncludesSearch = this.turkishToLower(item.name).includes(this.turkishToLower(searchTerm));
          const subItems = item.sub && filterRecursive(item.sub);
  
          if (itemNameIncludesSearch || (subItems && subItems.length > 0)) {
            acc.push({ ...item, sub: subItems });
          }
        }
        return acc;
      }, []);
    };
  
    const filteredMenuItems = filterRecursive(this.defaultMenu);
    this.menuItems.next(filteredMenuItems);
  }
  
  searchInMenu(item: any, searchTerm: string): boolean {
    const itemNameIncludesSearch = this.turkishToLower(item.name).includes(this.turkishToLower(searchTerm));
    const subItemsIncludeSearch = item.sub && item.sub.some(subItem => this.searchInMenu(subItem, searchTerm));
  
    return itemNameIncludesSearch || subItemsIncludeSearch;
  }

  toggleChildMenu(menuItem: IMenuItem): void {
    if (this.activeChildMenu === menuItem) {
      this.isChildMenuOpen = !this.isChildMenuOpen;
    } else {
      this.activeChildMenu = menuItem;
      this.isChildMenuOpen = true;
    }
  }

  localizationSourceName = AppConsts.localization.defaultLocalizationSourceName;

  constructor(
    // injector: Injector,
    private localizationService: LocalizationService,
    private _orderService:OrderServiceProxy,
    private _appService:AppSessionService,

    ) {
      this.menuVisibile=this._appService.application.params;
      this.getMenu();
  }



  l(key: string, ...args: any[]): string {
    let localizedText = this.localizationService.localize(key, this.localizationSourceName);

    if (!localizedText) {
      localizedText = key;
    }

    if (!args || !args.length) {
      return localizedText;
    }

    args.unshift(localizedText);
    return abp.utils.formatString.apply(this, args);
  }
  getMenu(){
     this.defaultMenu=[
    {
      name: this.l('InBound'),
      description: '',
      type: 'dropDown',
      icon: 'imind-box-open',
      disabled:this.menuVisibile!=null?this.menuVisibile.Where(p=>p.code=="InBound").FirstOrDefault().value==="True":false,
      sub: [
        { name: this.l('Waybills'), state: 'inbound/waybill', type: 'link', active: false },
        { name: this.l('WorkActivities'), state: 'inbound/workactivity', type: 'link' },
        { name: this.l('Examinations'), state: 'inbound/examination-list', type: 'link' }
      ]
    },
    {
      name: this.l('OutBound'),
      description: '',
      type: 'dropDown',
      icon: 'imind-box-close',
      disabled:this.menuVisibile!=null?this.menuVisibile.Where(p=>p.code=="OutBound").FirstOrDefault().value==="True":false,
      sub: [
        { name: this.l('Orders'), state: 'outbound/order/list', type: 'link', active: false },
        // { name: this.l('BackOrderOrderCreation'), state: 'outbound/order/back-unite', type: 'link' },
        {
          name: this.l('WorkActivity'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('CreateNew'), state: 'outbound/order/workactivity/create', type: 'link' },
              { name: this.l('List'), state: 'outbound/order/workactivity/list', type: 'link' },
            ]
        },
        { name: this.l('ControlPointScreen'), state: 'outbound/order/control-point/list', type: 'link' },
        {
          name: this.l('CombinableInvoiceOperations'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('CanCombinableInvoices'), state: 'outbound/order/combine-invoice', type: 'link' },
              { name: this.l('CombinedInvoices'), state: 'outbound/order/combine-invoice-report', type: 'link' },
            ]
        },
        { name: this.l('ListOfCancellationWorkActivityWaitingToBeReplaced'), state: 'outbound/order/cancel-placement-work-activity-list', type: 'link' }
      ]
    },
    {
      name: this.l('Production'),
      description: '',
      type: 'dropDown',
      icon: 'imind-factory-2',
      disabled:this.menuVisibile!=null?this.menuVisibile.Where(p=>p.code=="Production").FirstOrDefault().value==="True":false,
      sub:
        [
          { name: this.l('ProductionOperation'), state: 'production/list', type: 'link' },
          { name: this.l('CreateProcedurePackRecipe'), state: 'production/recipe-list', type: 'link' },
        ]
    },
    {
      name: this.l('Movements'),
      description: '',
      type: 'dropDown',
      icon: 'imind-repeat',
      disabled:this.menuVisibile!=null?this.menuVisibile.Where(p=>p.code=="Movements").FirstOrDefault().value==="True":false,
      sub: [
        {
          name: this.l('ProductMovements'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('BetweenTheStorages'), state: 'transfers/storage', type: 'link' },
              { name: this.l('BetweenTheShelves'), state: 'transfers/shelf', type: 'link' },
              { name: this.l('StockCorrection'), state: 'transfers/correction', type: 'link' },
              // { name: this.l('StockCorrectionShelf'), state: 'transfers/correction-shelf', type: 'link' },
              // { name: this.l('StockCorrectionStorage'), state: 'transfers/correction-storage', type: 'link' },
              // { name: this.l('EditShelf'), state: 'transfers/shelfcorrection', type: 'link' },
              { name: this.l('BetweenTheWarehouses'), state: 'transfers/warehouse', type: 'link' },
              { name: this.l('DatControlPoint'), state: 'transfers/controlpoint', type: 'link' },
              { name: this.l('BulkShelfTransfer'), state: 'transfers/all-products-on-shelf', type: 'link' },
              { name: this.l('StockVirman'), state: 'transfers/recode', type: 'link' },
              { name: this.l('StockReset'), state: 'transfers/stock-reset', type: 'link' },
            ]
        },
        {
          name: this.l('Replenishment'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('CreateWorkActivity'), state: 'transfers/replenishment-workactivity/create', type: 'link' },
              { name: this.l('List2'), state: 'transfers/replenishment-workactivity/list', type: 'link' },
            ]

        },
        { name: this.l('ProductPeriodicMovement'), state: 'movement/stock-periodic', type: 'link' },
        { name: this.l('ClientMovement'), state: 'movement/client-list', type: 'link' },
        { name: this.l('ProductOrderMovements'), state: 'movement/order-list', type: 'link' },
        { name: this.l('ProductClientBasedMovement'), state: 'movement/order-list-client', type: 'link' },
        { name: this.l('ProductProductBasedMovement'), state: 'movement/order-list-product', type: 'link' },


      ]
    },
    {
      name: this.l('StockTaking'),
      description: '',
      type: 'dropDown',
      icon: 'imind-building',
      disabled:this.menuVisibile!=null?this.menuVisibile.Where(p=>p.code=="StockTaking").FirstOrDefault().value==="True":false,
      sub: [
        { name: this.l('CreateStockTaking'), state: 'stocktaking/st-create-workactivity', type: 'link', active: false },
        { name: this.l('StockTakingList'), state: 'stocktaking/st-list-workactivity', type: 'link', active: false },
        { name: this.l('MasterStockTaking'), state: 'stocktaking/st-create-edit-action-process', type: 'link', active: false },
        { name: this.l('CreateStockTakingControlList'), state: 'stocktaking/st-create-control-list', type: 'link', active: false },
        { name: this.l('CreateStockTakingSupervisorList'), state: 'stocktaking/st-create-supervisor-list', type: 'link', active: false },
        {
          name: this.l('Reports'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('SpotCheckStockTakingReport'), state: 'stocktaking/reports/st-report-spotcheck-progress', type: 'link' },
              { name: this.l('StockTakingWorkActivityReport'), state: 'stocktaking/reports/st-report-detail-assigned-shelf-user-list', type: 'link' },
              { name: this.l('SupervisorControlStockTaking'), state: 'stocktaking/reports/st-report-supervisor-control-progress', type: 'link' },
              { name: this.l('ControlStockTaking'), state: 'stocktaking/reports/st-report-control-list-progress', type: 'link' },
              { name: this.l('ClosingStockTakingReport'), state: 'stocktaking/reports/st-report-completion', type: 'link' },
              { name: this.l('StockTakingProgressReport'), state: 'stocktaking/reports/st-report-detail-progress', type: 'link' },
              { name: this.l('FollowUpInstantStockTakingAddressIndexed'), state: 'stocktaking/reports/st-report-instant-quantity-address-based', type: 'link' },
              { name: this.l('FollowUpInstantStockTakingProductIndexed'), state: 'stocktaking/reports/st-report-instant-quantity-product-based', type: 'link' },
            ]
        },
      ]
    },
    {
      name: this.l('Definitions'),
      description: '',
      type: 'dropDown',
      icon: 'imind-data-center',
      disabled:this.menuVisibile!=null?this.menuVisibile.Where(p=>p.code=="Definitions").FirstOrDefault().value==="True":false,
      sub: [
        {
          name: this.l('Product'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('List2'), state: 'product/list', type: 'link' },
              { name: this.l('Barcode'), state: 'product/barcode', type: 'link' },
              { name: this.l('Container'), state: 'product/container', type: 'link' },
            ]
        },
        {
          name: this.l('Client'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('List2'), state: 'client/list', type: 'link' },
            ]
        },
        {
          name: this.l('Staff'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('List2'), state: 'users/list', type: 'link' },
              { name: this.l('Roles'), state: 'roles/list', type: 'link' },
            ]
        },
        {
          name: this.l('Company'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('Warehouses'), state: 'company/warehouse', type: 'link' },
              { name: this.l('Storages'), state: 'company/storage', type: 'link' },
              { name: this.l('Addresses'), state: 'company/shelf', type: 'link' },
              { name: this.l('ControlPoints'), state: 'company/control-point', type: 'link' },
              { name: this.l('VehicleCargo'), state: 'company/shipping-type', type: 'link' },
              { name: this.l('VehicleCargoPrioritization'), state: 'company/shipping-type-priority', type: 'link' },
              { name: this.l('Route'), state: 'company/shipping-route', type: 'link' },
              { name: this.l('PrintPoints'), state: 'company/printpoints', type: 'link' },
            ]
        }
      ]
    },
    {
      name: this.l('Reports'),
      description: '',
      type: 'dropDown',
      icon: 'imind-pie-chart',
      disabled:this.menuVisibile!=null?this.menuVisibile.Where(p=>p.code=="Reports").FirstOrDefault().value==="True":false,
      sub: [
        {
          name: this.l('Stock'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('StockCumulate'), state: 'reports/product/product-storage-quantity', type: 'link' },
              { name: this.l('StockErpDifference'), state: 'reports/product/stock-erp-diff', type: 'link' },
              { name: this.l('AddressedStockPrintOut'), state: 'reports/product/shelf-movements-storage-quantity', type: 'link' },
              { name: this.l('OutOfStockProducts'), state: 'reports/product/stock-out', type: 'link' },
              { name: this.l('OperationalOutOfStockProducts'), state: 'reports/product/stock-out-order', type: 'link' },
              { name: this.l('DimensionWeight'), state: 'reports/product/product-dimension-list', type: 'link' },
              { name: this.l('WithoutBarcode'), state: 'reports/product/no-barcode', type: 'link' },
              { name: this.l('VarietyShelf'), state: 'reports/product/shelf-types', type: 'link' },
              { name: this.l('DublicateBarcode'), state: 'reports/product/duplicate-products', type: 'link' },
              { name: this.l('BarcodeList'), state: 'reports/product/report-barcode-list', type: 'link' },
              { name: this.l('EmptyShelfList'), state: 'reports/product/shelf-empty', type: 'link' },
              { name: this.l('FullShelfList'), state: 'reports/product/shelf-full', type: 'link' },
              { name: this.l('StockMovements'), state: 'reports/product/stock-movements', type: 'link' },
              { name: this.l('ShelfMovements'), state: 'reports/product/shelf-movements', type: 'link' },
              { name: this.l('ShelfStorageQuantityDifferent'), state: 'reports/product/shelf-storage-quantity-different', type: 'link' },
              { name: this.l('ReportStockWarehouseList'), state: 'reports/product/report-stock-warehouse-diff-list', type: 'link' }

            ]
        },
        {
          name: this.l('InternalMovements'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('BetweenTheStorages'), state: 'reports/movement/storage-transfer', type: 'link' },
              { name: this.l('ReplenishmentMovements'), state: 'reports/movement/replenishment', type: 'link' },
              { name: this.l('InternalMovementsOperator'), state: 'reports/movement/operator-movement-shelf', type: 'link' },
              { name: this.l('InternalMovementsOperatorWithTypes'), state: 'reports/movement/operator-movement-by-types', type: 'link' },
              { name: this.l('InternalMovementsAddress'), state: 'reports/movement/shelf-transfer', type: 'link' },
              { name: this.l('AllInternalMovements'), state: 'reports/movement/all', type: 'link' },
            ]
        },
        {
          name: this.l('ERP'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('ERPTransfer'), state: 'reports/erp/transfer-to', type: 'link' },
              { name: this.l('ERPTransferFail'), state: 'reports/erp/erp-transfer-fail', type: 'link' },
            ]
        },
        {
          name: this.l('Order'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('ClientBasedOutBoundApprovedOrders'), state: 'reports/order/order-approved-client', type: 'link' },
              { name: this.l('ProductBasedOutBoundApprovedOrders'), state: 'reports/order/order-approved-product', type: 'link' },
              { name: this.l('ControlPointStatus'), state: 'reports/order/control-point-status', type: 'link' },
              { name: this.l('OrderPackageList'), state: 'reports/order/bundle-list', type: 'link' },
              { name: this.l('OrderControllTime'), state: 'reports/order/control-time', type: 'link' },
              { name: this.l('OrderFulfillmentStatus'), state: 'reports/order/fulfillment-list', type: 'link' },
              { name: this.l('ProductBasedOrderFulfillmentStatus'), state: 'reports/order/fulfillment-list-product', type: 'link' },
              { name: this.l('FinishedInvoice'), state: 'reports/order/invoice', type: 'link' },
              { name: this.l('MultipleFinishedInvoice'), state: 'reports/order/multiple-invoice', type: 'link' },
              { name: this.l('FinishedOrderDesiReport'), state: 'reports/order/finished-order-desi', type: 'link' },
              { name: this.l('FinishedWarrantyOrderReport'), state: 'reports/order/finished-warranty-order', type: 'link' },
              { name: this.l('OrderShelfMovement'), state: 'reports/order/movement-shelf', type: 'link' },
              { name: this.l('WaitingForReplacementOrders'), state: 'reports/order/pending-replacement', type: 'link' },
              { name: this.l('OrderShippingStatus'), state: 'reports/order/shipment-status', type: 'link' },
              { name: this.l('WaitingForOutBoundControlProductBasedOrders'), state: 'reports/order/pending-control-product', type: 'link' },
              { name: this.l('WaitingForOutBoundControlClientBasedOrders'), state: 'reports/order/pending-control-client', type: 'link' },
              { name: this.l('WaitingClientBasedOrders'), state: 'reports/order/pending-client', type: 'link' },
              { name: this.l('WaitingProductBasedOrders'), state: 'reports/order/pending-product', type: 'link' },
              { name: this.l('CrossDock'), state: 'reports/order/crossdock', type: 'link' },
              { name: this.l('ShippingStatus'), state: 'reports/order/order-shipping-report', type: 'link' },
              { name: this.l('VehicleLoadedOrders'), state: 'reports/order/finished-shipping-report', type: 'link' },
              { name: this.l('WaitinForCargoOrders'), state: 'reports/order/pending-shipping-report', type: 'link' },
              { name: this.l('BalanceOrderReport'), state: 'reports/order/order-balance/list', type: 'link' },
              { name: this.l('NotInvoice'), state: 'reports/order/notinvoice', type: 'link' },
              { name: this.l('InstantOrderTrackingReport'), state: 'reports/order/order-tracking-report', type: 'link' },
              { name: this.l('DeletedList'), state: 'reports/order/order-waybill-deleted/list', type: 'link' }
            ]
        },
        {
          name: this.l('InBound'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('Control'), state: 'reports/inbound/control', type: 'link' },
              { name: this.l('Placement'), state: 'reports/inbound/placement', type: 'link' },
              { name: this.l('WaitingClientPremise'), state: 'reports/inbound/waybill-pending-client', type: 'link' },
              { name: this.l('WaitingProductQuantityVarietyPremise'), state: 'reports/inbound/waybill-pending-product', type: 'link' },
              { name: this.l('PlacementFinished'), state: 'reports/inbound/placement-finished', type: 'link' },
              { name: this.l('PlacementPendingProduct'), state: 'reports/inbound/placement-pending-product', type: 'link' },
              { name: this.l('UnderOverReport'), state: 'reports/inbound/under-over', type: 'link' },
              { name: this.l('Finished-Time'), state: 'reports/inbound/finished-time', type: 'link' },
              { name: this.l('Time-Between-Control-Placement'), state: 'reports/inbound/time-between-control-placement', type: 'link' },
              { name: this.l('WaybillPhoto'), state: 'reports/inbound/waybill-photo', type: 'link' },
            ]
        },
        {
          name: this.l('Performance'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('OrderControlPrintOutForOperator'), state: 'reports/performance/operator-order-control', type: 'link' },
              { name: this.l('OrderCollectPrintOutForOperator'), state: 'reports/performance/operator-order-picker', type: 'link' },
              { name: this.l('InBoundPlacementPrintOutForOperator'), state: 'reports/performance/operator-waybill-placement', type: 'link' },
              { name: this.l('InBoundControlPrintOutForOperator'), state: 'reports/performance/operator-waybill-control', type: 'link' },
              { name: this.l('OrderCollectStatusForOperator'), state: 'reports/performance/operator-order-picker-status', type: 'link' },
              { name: this.l('OperatorEfficiencyChartsDaily'), state: 'reports/performance/operator-daily-effiency-graphs', type: 'link' },
              { name: this.l('GeoMapLocation'), state: 'reports/performance/geo-map-location', type: 'link' },

              /*      Bu 4 rapor için metodlar yazılmamış     */
              // { name: this.l('AllMovementPrinOutForOperator'), state: 'reports/performance/operator-all', type: 'link' },
              // { name: this.l('InBoundMovementPrinOutForOperator'), state: 'reports/performance/operator-movement-waybill-in', type: 'link' },
              // { name: this.l('PlacementMovementPrintOutForOperator'), state: 'reports/performance/operator-movement-placement', type: 'link' },
              // { name: this.l('CollectedMovementPrintOutForOperator'), state: 'reports/performance/operator-movement-picking', type: 'link' },

            ]
        }
      ]
    },
    {
      name: this.l('Settings'),
      description: '',
      type: 'dropDown',
      icon: 'imind-gear',
      disabled:this.menuVisibile!=null?this.menuVisibile.Where(p=>p.code=="Settings").FirstOrDefault().value==="True":false,
      sub: [
        {
          name: this.l('CompanyInformation'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('List2'), state: 'company/list', type: 'link' },
              { name: this.l('DataSource'), state: 'company/datasource', type: 'link', active: false },
            ]
        },
        {
          name: this.l('GeneralSettings'),
          state: 'common-settings',
          type: 'link'
        },
        {
          name: this.l('Sync'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('Settings'), state: 'sync/setting', type: 'link' },
              { name: this.l('Operations'), state: 'sync/list', type: 'link' },
              { name: this.l('LoadOrderWaybill'), state: 'sync/order-waybill-from-erp', type: 'link' }
            ]
        },
        {
          name: this.l('NotificationSettings'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('NotificationGroups'), state: 'notifications/notification-group//list', type: 'link' },
              { name: this.l('SendNotificationSection'), state: 'notifications/send-notification', type: 'link', active: false },
            ]
        },

        {
          name: this.l('System'),
          type: 'dropDown',
          sub:
            [
              { name: this.l('Parameters'), state: 'sync/parameters', type: 'link' }
            ]
        },
      ]
    }
  ];

  const filteredMenuItems = this.defaultMenu.filter((item) => !item.disabled);
  this.menuItems.next(filteredMenuItems);  
  }

  //  // sets iconMenu as default;
  //  menuItems = new BehaviorSubject<IMenuItem[]>(this.defaultMenu.Where(p=>p.disabled==false).ToArray());
  //  // navigation component has subscribed to this Observable
  //  menuItems$ = this.menuItems.asObservable();



  // You can customize this method to supply different menu for
  // different user type.
  // publishNavigationChange(menuType: string) {
  //   switch (userType) {
  //     case 'admin':
  //       this.menuItems.next(this.adminMenu);
  //       break;
  //     case 'user':
  //       this.menuItems.next(this.userMenu);
  //       break;
  //     default:
  //       this.menuItems.next(this.defaultMenu);
  //   }
  // }
}
